import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/warehouse/outbound/record/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/warehouse/outbound/detail', Object.assign({}, options, { params }))

// 获取总金额
export const getSummary = (params, options) =>
request.get('/api/v4ward/warehouse/outbound/record/summary', Object.assign({}, options, { params }))

export const getUserlist = (params, options) =>
request.get('/api/v4ward/user/userList', Object.assign({}, options, { params }));

export const update = (params, options) =>
request.post('/api/v4ward/custom/form/main/submit', params,options)
// 确认领料成功
export const confirm = (params, options) =>
request.post('/api/v4ward/warehouse/outbound/confirm', params,options)

// 申请获取仓库下拉列表 /v4ward/warehouse/getWarehouseListApply
export const getWarehouseListApply = (params, options) =>
request.get('/api/v4ward/warehouse/getWarehouseListApply', Object.assign({}, options, { params }));

// 通过当前登录人获取科室
export const treeDeptsByIds = (params, options) =>
request.get('/api/v4ward/dept/listByUser', Object.assign({}, options, { params }));

